import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4201fa81")

_pushScopeId("data-v-4201fa81")
const _hoisted_1 = {
  key: 0,
  type: "button",
  class: "button doc-button-icon",
  title: "Show supported docs"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-eye" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("td", null, [
    (_ctx.dataItem.hasDocs)
      ? (_openBlock(), _createBlock("button", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true)
  ]))
})